import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '产品与服务',
    links: [
      { label: '营销数字化战略&咨询', path: '/products' },
      { label: '营销数字化运营陪跑', path: '/products' },
      { label: '五位一体营销数字化平台搭建', path: '/products' },
      { label: 'bC一体化SaaS系统', path: '/products' },
      { label: '大数据运营服务', path: '/products' },
    ],
  },
  {
    title: '解决方案',
    links: [
      { label: '食品行业', path: '/solutions' },
      { label: '饮料行业', path: '/solutions' },
      { label: '日化个护', path: '/solutions' },
      { label: '调味品行业', path: '/solutions' },
      { label: '啤酒行业', path: '/solutions' },
      { label: '乳制品行业', path: '/solutions' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '公司介绍', path: '/about' },
      { label: '成功案例', path: '/cases' },
      { label: '资讯中心', path: '/insights' },
      { label: '联系我们', path: '/contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#F5F7FA] border-t border-gray-200">
      {/* Top service bar */}
      <div className="border-b border-gray-200 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-16 py-5">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { icon: 'ri-shield-check-line', title: '专业技术服务', desc: '10年行业深耕积累' },
              { icon: 'ri-customer-service-2-line', title: '1v1专属顾问', desc: '全程陪伴式服务' },
              { icon: 'ri-time-line', title: '7×24小时响应', desc: '随时随地在线支持' },
              { icon: 'ri-award-line', title: '20+ 标杆案例', desc: '覆盖多个细分赛道' },
            ].map((item, i) => (
              <div key={i} className="flex items-center gap-3">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-[#1E5FAD]/8 shrink-0">
                  <i className={`${item.icon} text-[#1E5FAD] text-base`} />
                </div>
                <div>
                  <p className="text-sm font-semibold text-[#333333]">{item.title}</p>
                  <p className="text-xs text-[#666666]">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Main footer */}
      <div className="w-full px-4 md:px-8 lg:px-16 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {/* Brand column */}
          <div className="lg:w-[280px] shrink-0">
            <Link to="/">
              <img
                src="/images/logo.png"
                alt="融慧数科"
                className="h-8 w-auto object-contain mb-4"
              />
            </Link>
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-[#666666]">
                <i className="ri-phone-line text-[#1E5FAD] text-base w-4" />
                <span>18688924109（柳雪琴）</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-[#666666]">
                <i className="ri-mail-line text-[#1E5FAD] text-base w-4" />
                <span>liuxueqin@ronghuidt.com</span>
              </div>
              <div className="flex items-start gap-2 text-sm text-[#666666]">
                <i className="ri-map-pin-line text-[#1E5FAD] text-base w-4 mt-0.5 shrink-0" />
                <span>深圳市宝安区前海科兴科学园5号楼702</span>
              </div>
            </div>
          </div>

          {/* Nav columns */}
          <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
            {footerLinks.map((col) => (
              <div key={col.title}>
                <h4 className="text-sm font-bold text-[#333333] mb-4">{col.title}</h4>
                <ul className="space-y-2.5">
                  {col.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-[#666666] hover:text-[#1E5FAD] transition-colors"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* QR / CTA column */}
          <div className="lg:w-[200px] shrink-0">
            <h4 className="text-sm font-bold text-[#333333] mb-4">关注我们</h4>
            <div className="flex gap-3">
              <div className="text-center">
                <div className="w-20 h-20 bg-white border border-gray-200 rounded-lg overflow-hidden mb-1.5">
                  <img
                    src="/images/footer-qrcode-wechat.jpg"
                    alt="公众号"
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-xs text-[#666666]">公众号</p>
              </div>
              <div className="text-center">
                <div className="w-20 h-20 bg-white border border-gray-200 rounded-lg overflow-hidden mb-1.5">
                  <img
                    src="/images/footer-qrcode-douyin.jpg"
                    alt="视频号"
                    className="w-full h-full object-cover"
                  />
                </div>
                <p className="text-xs text-[#666666]">视频号</p>
              </div>
            </div>
            <Link
              to="/contact"
              className="mt-5 flex items-center justify-center gap-1.5 w-full py-2.5 bg-[#00AEEF] text-white text-sm font-semibold rounded-lg hover:bg-[#0099d4] transition-colors whitespace-nowrap"
            >
              <i className="ri-calendar-check-line" />
              预约演示
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-gray-200 bg-white">
        <div className="w-full px-4 md:px-8 lg:px-16 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-[#999]">
          <p>© 2026 深圳融慧数科有限公司 · 快消行业营销数字化最佳实践者</p>
          <div className="flex items-center gap-4">
            <a href="https://beian.miit.gov.cn/" target="_blank" rel="nofollow" className="hover:text-[#1E5FAD] transition-colors">粤ICP备2024304970号-1</a>
            <span>|</span>
            <Link to="/privacy" className="hover:text-[#1E5FAD] transition-colors">隐私政策</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
